import { render, staticRenderFns } from "./activeWonderful.vue?vue&type=template&id=44249e84&scoped=true&"
import script from "./activeWonderful.vue?vue&type=script&lang=js&"
export * from "./activeWonderful.vue?vue&type=script&lang=js&"
import style0 from "./activeWonderful.vue?vue&type=style&index=0&id=44249e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44249e84",
  null
  
)

export default component.exports